"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _misc = require("./misc");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultDedupRules = [{
  key: 'layer',
  operation: 'useOriginal'
}, {
  key: 'product',
  operation: 'useNew'
}];

var findDedupRule = function findDedupRule(obj, rules) {
  return rules.find(function (rule) {
    return rule.key in obj;
  });
};

// Transforms item (or item in cache) as needed to fulfill dedup rule
// Objects marked with keys __rsw_dedup_remove__ will be removed downstream
var decorateUsingDedupRule = function decorateUsingDedupRule(incomingItem, dedupRule, cache) {
  // make a copy of item
  var item = _objectSpread({}, incomingItem);

  var cacheKey = item[dedupRule.key];

  if (!cacheKey) {
    return item;
  }

  var cachedItem = cache[cacheKey];

  if (!cachedItem) {
    cache[cacheKey] = item;
    return item;
  }

  switch (dedupRule.operation) {
    case 'useOriginal':
      {
        item.__rsw_dedup_remove__ = true;
        return item;
      }

    case 'useNew':
      {
        cachedItem.__rsw_dedup_remove__ = true;
        cache[cacheKey] = item;
        return item;
      }

    case 'merge':
      {
        var merged = _objectSpread(_objectSpread({}, cachedItem), item);

        cachedItem.__rsw_dedup_remove__ = true;
        cache[cacheKey] = merged;
        return merged;
      }
  }
}; // Passed two arrays, will deduplicate items according to the dedup rules specified in this file.
// First matching rule (where object has a property matching rule key) will be used
//
// When two objects are found with matching values for the key specified in the rule,
// one of the following dedup operations will take place:
//   useOriginal: use first object
//   useNew: use incoming object
//   merge: perform shallow merge on original and imcoming object


var dedupArray = function dedupArray(source, target, dedupRules) {
  var rules = dedupRules || defaultDedupRules;
  var merged = [].concat((0, _toConsumableArray2["default"])(source), (0, _toConsumableArray2["default"])(target));
  var cache = {};
  return merged.map(function (item) {
    if (!(0, _misc.isObject)(item)) {
      return item;
    } else {
      var dedupRule = findDedupRule(item, rules);

      if (dedupRule) {
        return decorateUsingDedupRule(item, dedupRule, cache);
      } else {
        return item;
      }
    }
  }).filter(function (item) {
    return !item.__rsw_dedup_remove__;
  });
};

var _default = dedupArray;
exports["default"] = _default;